import * as yup from "yup";
import { getTranslationPayload as t } from "src/i18n";
import { ERROR_MESSAGES } from "../../constants/Form";

export const AGENT_VARIABLES = [
  "first_name",
  "last_name",
  "full_name",
  "email",
];

export const HTTPFormMeta = {
  getInitialValues: function () {
    return {
      method: "POST",
      url: "",
      headers: [],
      params: [],
      body: "",
      body_type: "JSON",
      body_params: [],
    };
  },
  getSchema: function () {
    return {
      method: yup.string().required(ERROR_MESSAGES.required),
      url: yup.string().required(ERROR_MESSAGES.required),
      headers: yup.array().of(
        yup.object().shape({
          key: yup.string(),
          value: yup.mixed().when("key", {
            is: (val) => val,
            then: yup.string().required(ERROR_MESSAGES.required),
          }),
        })
      ),
      params: yup.array().of(
        yup.object().shape({
          key: yup.string(),
          value: yup.mixed().when("key", {
            is: (val) => val,
            then: yup.string().required(ERROR_MESSAGES.required),
          }),
        })
      ),
      body: yup.string(),
      body_type: yup.string(),
      body_params: yup.mixed().when("bodyType", {
        is: "STRUCTURED",
        then: yup.array().of(
          yup.object().shape({
            key: yup.string(),
            value: yup.mixed().when("key", {
              is: (val) => val,
              then: yup.string().required(ERROR_MESSAGES.required),
            }),
          })
        ),
      }),
    };
  },
  FIELDS: {
    url: {
      key: "url",
      label: t("url", "URL"),
      help: "",
      placeholder: t("enter-a-valid-url", "Enter a valid URL"),
    },
    body: {
      key: "body",
      label: t("request-body", "Request Body"),
      help: "",
      placeholder: t("insert-request-body", "Insert request body"),
    },
    body_type: {
      key: "body_type",
      label: t("request-body-type", "Request body type"),
    },
    body_params: {
      form_key: {
        key: "key",
        label: t("key", "Key"),
        help: "",
        placeholder: t("key", "Key"),
      },
      form_value: {
        key: "value",
        label: t("value", "Value"),
        help: "",
        placeholder: t("value", "Value"),
      },
    },
    method: {
      key: "method",
      label: t("method-type", "Method type"),
      help: t("select-a-http-method", "Select a HTTP Method"),
    },
    headers: {
      key: {
        key: "key",
        label: t("key", "Key"),
        help: "",
        placeholder: t("key", "Key"),
      },
      value: {
        key: "value",
        label: t("value", "Value"),
        help: "",
        placeholder: t("value", "Value"),
      },
    },
    params: {
      key: {
        key: "key",
        label: t("key", "Key"),
        help: "",
        placeholder: t("key", "Key"),
      },
      value: {
        key: "value",
        label: t("value", "Value"),
        help: "",
        placeholder: t("value", "Value"),
      },
    },
  },
  METHOD_TYPES: [
    {
      label: "GET",
      value: "GET",
      icon: (
        <div
          className="h-5 w-5 rounded-full font-extrabold text-blue-500"
          aria-hidden="true"
        >
          G
        </div>
      ),
      help: t("make-a-get-request", "Make a get request"),
    },
    {
      label: "POST",
      value: "POST",
      icon: (
        <div
          className="h-5 w-5 rounded-full font-extrabold text-green-500"
          aria-hidden="true"
        >
          P
        </div>
      ),
      help: t("make-a-post-request", "Make a post request"),
    },
    {
      label: "PUT",
      value: "PUT",
      icon: (
        <div
          className="h-5 w-5 rounded-full font-extrabold text-yellow-500"
          aria-hidden="true"
        >
          P
        </div>
      ),
      help: t("make-a-put-request", "Make a put request"),
    },
    {
      label: "PATCH",
      value: "PATCH",
      icon: (
        <div
          className="h-5 w-5 rounded-full font-extrabold text-purple-500"
          aria-hidden="true"
        >
          P
        </div>
      ),
      help: t("make-a-patch-request", "Make a patch request"),
    },
    {
      label: "DELETE",
      value: "DELETE",
      icon: (
        <div
          className="h-5 w-5 rounded-full font-extrabold text-red-500"
          aria-hidden="true"
        >
          D
        </div>
      ),
      help: t("make-a-delete-request", "Make a delete request"),
    },
  ],
  BODY_TYPES: [
    {
      label: t("multipart-form", "Multipart Form"),
      value: "multipart/form-data",
      type: "STRUCTURED",
    },
    {
      label: t("form-url-encoded", "Form URL Encoded"),
      value: "application/x-www-form-urlencoded",
      type: "STRUCTURED",
    },
    {
      label: "JSON",
      value: "application/json",
      type: "TEXT",
    },
    {
      label: "XML",
      value: "application/xml",
      type: "TEXT",
    },
    {
      label: "YAML",
      value: "text/yaml",
      type: "TEXT",
    },
    {
      label: t("plain", "Plain"),
      value: "text/plain",
      type: "TEXT",
    },
    {
      label: t("none", "None"),
      value: "NONE",
      type: "OTHER",
    },
  ],
};
